/**
 * @fileoverview POST handler for the "/app_settings/custom_attribute_schema" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomAttributeSchemaCacheKeys } from "./constants";
import type { AppSettingsCustomAttributeSchemaProps, AppSettingsCustomAttributeSchemaResult } from "./types";

export const postAppSettingsCustomAttributeSchema = reactQueryMutationAdapter(
  appSettingsCustomAttributeSchemaCacheKeys,
  (props: AppSettingsCustomAttributeSchemaProps): Promise<AppSettingsCustomAttributeSchemaResult> => {
    return fetch("/app_settings/custom_attribute_schema", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
